/**
 * The Compras permissions, apart from the operations' names: the shell asks for one above every screen, so this file is
 * in the entry chunk and the operations are not.
 */

export const COMPRAS_PERMISSIONS = Object.freeze({
  read: 'inventory.purchase-document.read',
  capture: 'inventory.purchase-document.capture',
  resolve: 'inventory.purchase-document.resolve',
  register: 'inventory.purchase-register.read',
} as const);
